import { FilterButton } from '../../../../components/buttons/FilterButton';
import { toDateString } from '../../../../utils/TimeUtils';
import { DEFAULT_DATE_TIME } from '../../../../components/common/Constants';
import { DateTimePicker } from '../../../../components/dateTimePicker/DateTimePicker';
import { useTranslation } from 'react-i18next';

export const OrderFilter = ({ filter, doFilter, statusTypes }) => {
    const { t } = useTranslation();

    const setFrom = (value) => {
        filter.from = toDateString(value, DEFAULT_DATE_TIME);
    };

    const setTill = (value) => {
        filter.till = toDateString(value, DEFAULT_DATE_TIME);
    };

    return (
        <div className={'filter'} id={'filter-element'}>
            <div className={'mb-3'}>
                <span>{t('order:status')}</span>
                <select className={'form-select'}
                        id={'filter-by-type-id'}
                        defaultValue={filter.status}
                        onChange={(e) =>
                            filter.status = e.target.value !== ''
                                ? e.target.value
                                : null}>
                    <option></option>
                    {statusTypes.map((type) => {
                        return (
                            <option value={type} key={type}>
                                {t('order:statuses.' + type)}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className={'mb-3'}>
                <span>{t('order:orderedAtFrom')}</span>
                <DateTimePicker value={filter.from}
                                onChange={setFrom}
                                dateFormat={DEFAULT_DATE_TIME}
                                showTime={true}>
                </DateTimePicker>
            </div>
            <div className={'mb-3'}>
                <span>{t('order:orderedAtTill')}</span>
                <DateTimePicker value={filter.till}
                                onChange={setTill}
                                dateFormat={DEFAULT_DATE_TIME}
                                showTime={true}>
                </DateTimePicker>
            </div>
            <div className={'center'}>
                <FilterButton onClick={doFilter}></FilterButton>
            </div>
        </div>
    );

};